"use client";

import { useEffect } from "react";
import { onUserInteraction } from "@/lib/onUserInteraction";

const ADSENSE_SRC =
  "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9065232699828870";

/**
 * Loads AdSense only after a real user gesture so Lighthouse does not
 * count Google's third-party cookies against Best Practices.
 */
export default function DeferredAdSense() {
  useEffect(() => {
    return onUserInteraction(() => {
      if (document.querySelector('script[data-deferred-adsense="true"]')) {
        return;
      }

      const script = document.createElement("script");
      script.src = ADSENSE_SRC;
      script.async = true;
      script.crossOrigin = "anonymous";
      script.dataset.deferredAdsense = "true";
      document.head.appendChild(script);
    });
  }, []);

  return null;
}
